<template>
  <div>
    <div
      class="address-common van-hairline--bottom"
      v-for="(item,index) in addressList"
      :key="index"
      @click="address(item.id)"
    >
      <div class="address van-ellipsis">{{item.addressInfo}}{{item.houseNumber}}</div>
      <div class="info">
        <span>{{ item.name }}</span>
        <span>{{ item.mobile }}</span>
      </div>
    </div>
    <div
      class="notHave"
      v-if="addressList.length == 0"
    >
      <i class="iconfont icon-zu"></i>
      <p>暂无收货地址</p>
      <p>请到“个人中心→我的收货地址”中新增地址</p>
    </div>
  </div>
</template>

<script>
import { getAddressList, address } from "@/api/join";
export default {
  data() {
    return {
      addressList: [],
    };
  },
  methods: {
    address(id) {
      address({ memberAddressId: id }).then((res) => {
        this.$router.go(-1);
      });
    },
  },
  mounted() {
    getAddressList(`type=0&token=${this.$store.getters.token}`).then((res) => {
      if (res.appStatus.errorCode == 0) {
        this.addressList = res.content;
      }
    });
  },
};
</script>

<style lang="scss" scoped>
.address-common {
  width: 345px;
  height: 50px;
  margin: 0 auto;
  display: flex;
  justify-content: center;
  flex-direction: column;
  font-size: 15px;
  .address {
    font-weight: 800;
  }
  .info {
    margin-top: 3px;
    color: #8d8d8d;
    span:first-child {
      margin-right: 10px;
    }
  }
}
.notHave {
  margin-top: 178px;
  text-align: center;
  i {
    font-size: 107px;
    color: #d5d5d7;
  }
  p {
    font-size: 15px;
    color: #a3a2a2;
    margin-top: 32px;
    &:last-child {
      margin-top: 3px;
    }
  }
}
</style>